export const USER_MANAGEMENT_DEFAULTS = {
    // Tab labels
    TAB_USER_TYPE: 'User Type',
    TAB_USER_INFORMATION: 'User Information',
    TAB_ASSIGN_USER: 'Assign User to Account(s)',

    // Section headings
    HEADING_USER_TYPE: 'Please select a type for this user:',
    HEADING_ASSIGN_USER: 'Assign User to Account(s)',

    // User type option labels
    LABEL_REGULAR_USER: 'Regular User',
    LABEL_COP_ADMIN: 'COP Administrator',
    LABEL_COP_USER_MANAGER: 'COP User Manager',

    // User type descriptions
    DESC_REGULAR_USER:
        'Select this option to create a regular user who only has access to specified COP accounts which are assigned in the tab Assign user to accounts.',
    DESC_COP_ADMIN:
        'Select this option to create a system-wide administrator who has unrestricted access to the COP and all its resources.',
    DESC_COP_USER_MANAGER:
        'Select this option to create a user manager who has access to the COP User Management and all its resources.',

    // Checkbox / toggle labels
    LABEL_MICROSCADA_PORTAL: 'Allow access to MicroSCADA X Partners Portal:',
    LABEL_SF_CASE_MGMT: 'Allow access to Salesforce Global Case Management',
    LABEL_SF_PSA: 'Allow access to Salesforce Professional Services Automation',
    LABEL_GA_SHIELD: 'GA Shield User',
    LABEL_MULTI_ACCOUNT: 'User can access multiple accounts',

    // Form field labels
    LABEL_FIRST_NAME: 'First Name',
    LABEL_LAST_NAME: 'Last Name',
    LABEL_FUNCTION: 'Function',
    LABEL_EMAIL: 'E-mail',
    LABEL_ACCOUNTS: 'Account(s)',
    LABEL_USER_ROLE: 'User Role',
    LABEL_PRODUCT: 'Product',

    // Placeholders
    PLACEHOLDER_FIRST_NAME: 'Type First Name',
    PLACEHOLDER_LAST_NAME: 'Type Last Name',
    PLACEHOLDER_FUNCTION: 'Type Function',
    PLACEHOLDER_EMAIL: 'Type E-mail',
    PLACEHOLDER_ACCESS_ROLE: 'Select access role',
    ACCESS_ROLE_MEMBER_MSG: 'Edit page contents, publish news feed',
    ACCESS_ROLE_VISITOR_MSG: 'Read-only access',
    PLACEHOLDER_ACCOUNTS: 'Select account(s)',
    PLACEHOLDER_USER_ROLE: 'Select user role',
    PLACEHOLDER_PRODUCT: 'Select product(s)',
    MSG_SELECT_ACCOUNT_ROLE_FIRST: 'Please select an account and role first',

    // Buttons
    BTN_NEXT: 'Next',
    BTN_CANCEL: 'Cancel',
    BTN_ADD_USER: 'Add User',
    BTN_SAVE_CHANGES: 'Save Changes',
    BTN_SAVING: 'Saving...',
    BTN_ADD_ASSIGNMENT: '+',
    TOOLTIP_ADD_ASSIGNMENT: 'Please select at least one account and a corresponding role',

    // ARIA labels
    ARIA_ADD_ASSIGNMENT: 'Add assignment',
    ARIA_REMOVE_ASSIGNMENT: 'Remove assignment',

    // Mode / badge display labels
    MODE_LABEL_ADD: 'Add',
    MODE_LABEL_EDIT: 'Edit',

    // Assignment table display values
    LABEL_NO_SLA_DISPLAY: 'No SLA',
    LABEL_EMPTY_VALUE: '-',

    // User type semantic values
    USER_TYPE_REGULAR: 'regular',
    USER_TYPE_ADMIN: 'admin',
    USER_TYPE_MANAGER: 'manager',

    // Action type semantic values
    ACTION_TYPE_ADD: 'Add',
    ACTION_TYPE_EDIT: 'Edit',

    // Partner portal access semantic values
    ACCESS_ROLE_NONE: 'None',
    ACCESS_ROLE_MEMBER: 'Member',
    ACCESS_ROLE_VISITOR: 'Visitor',

    // Session storage key for the logged-in user object
    SESSION_KEY_CURRENT_USER: 'cop:current-user',

    // Toast messages
    TOAST_SUCCESS_CREATE_USER: 'User created successfully.',
    TOAST_SUCCESS_UPDATE_USER: 'User updated successfully.',
    TOAST_SUCCESS_UPDATE_ROLES: 'User role updated.',
    TOAST_ERROR_LOAD_USER: 'Failed to load user data. Please try again.',
    TOAST_ERROR_CREATE_USER: 'Failed to create user. Please try again.',
    TOAST_ERROR_UPDATE_USER: 'Failed to update user. Please try again.',
    TOAST_ERROR_UPDATE_ROLES: 'Failed to update user roles. Please try again.',
    TOAST_ERROR_LOAD_FORM_DATA: 'Failed to load form data. Please try again.',

    // Cancel confirm dialog
    CANCEL_CONFIRM_MESSAGE: 'Are you sure you want to cancel?',
    CANCEL_CONFIRM_SUBTEXT: 'Your changes will not be saved.',
    CANCEL_CONFIRM_YES: 'Yes',
    CANCEL_CONFIRM_NO: 'No',

    // Validation messages
    VALIDATION_EMAIL_EMPTY: 'No valid email address has been defined.',
    VALIDATION_EMAIL_FORMAT: 'Invalid email address format (e.g. user@domain.com).',
    VALIDATION_EMAIL_EXISTS: 'An account with this email address already exists.',
    VALIDATION_USER_TYPE: 'Please select a user type.',
    VALIDATION_FIRST_NAME: 'First Name is required.',
    VALIDATION_LAST_NAME: 'Last Name is required.',
    VALIDATION_FUNCTION: 'Function is required.',
    VALIDATION_ROLE: 'Please select a user role.',
    VALIDATION_PRODUCT: 'Please select at least one product.',
    VALIDATION_NO_ASSIGNMENTS: 'Please add at least one account assignment using the + button.',
    VALIDATION_DUPLICATE_ACCOUNT: 'This account has already been added.',
    VALIDATION_SINGLE_ACCOUNT_ROLE: "Users having role 'CustomerUser' or 'CustomerManager' can only be assigned to one account.",
} as const
